import { NgModule } from '@angular/core';
import { ButtonComponent } from './button/button.component';
import { ButtonDirective } from './button/button.directive';
import { IconButtonComponent } from './icon/icon-button.component';
import { IconButtonDirective } from './icon/icon-button.directive';
import { LinkComponent } from './link/link.component';

@NgModule({
  imports: [
    ButtonComponent,
    IconButtonComponent,
    LinkComponent,
    ButtonDirective,
    IconButtonDirective,
  ],
  exports: [
    ButtonComponent,
    IconButtonComponent,
    LinkComponent,
    ButtonDirective,
    IconButtonDirective,
  ],
})
export class ButtonModule {}
